import React, { useState } from 'react';
import { PropTypes } from 'utils/wrappers';
import FinanceIt from 'components/Page/Property/Part/FinanceIt';
import classes from 'components/Page/Property/styles/PaymentCalculator.module.scss';
import { Button } from 'reactstrap';
import PayInFull from 'components/Page/Property/Part/PayInFull';

const PaymentCalculator = ({ property, className, onBuy }) => {
    const [showFinance, setShowFinance] = useState(true);

    return (
        <div className={`${className} ${classes.wrapper} p-4`}>
            <div className={`d-flex flex-row justify-content-around ${classes.toggle}`}>
                <a
                    className={`d-flex justify-content-center w-50 p-2 ${showFinance ? classes.active : ''}`}
                    onClick={() => setShowFinance(true)}
                >
                    Finance It
                </a>
                <a
                    className={`d-flex justify-content-center w-50 p-2 ${!showFinance ? classes.active : ''}`}
                    onClick={() => setShowFinance(false)}
                >
                    Pay in Full
                </a>
            </div>
            <div className={'mt-2 mb-4'}>
                {showFinance ? <FinanceIt property={property} /> : <PayInFull property={property} />}
            </div>
            <div className={classes['buy-button']}>
                <Button color='primary' size='lg' className={classes.button} onClick={onBuy}>
                    Buy it now
                </Button>
            </div>
        </div>
    );
};

PaymentCalculator.propTypes = {
    property: PropTypes.shape({
        listingId: PropTypes.string.isRequired,
    }).isRequired,
    className: PropTypes.string,
    onBuy: PropTypes.func.isRequired,
};

export default PaymentCalculator;
